export const SAVE_PROJECT_ACCESS = "SAVE_PROJECT_ACCESS"
export const SAVE_PROJECT_ACCESS_PENDING = "SAVE_PROJECT_ACCESS_PENDING"
export const SAVE_PROJECT_ACCESS_FULFILLED = "SAVE_PROJECT_ACCESS_FULFILLED"
